import { Header } from "~/components/Shared/Header";
import { SearchInput } from "~/ui/SearchInput";

interface FirmwareHeaderProps {
  title: string;
  badgeText: string;
  setSearchText: (text: string) => void;
  onUploadClick: () => void;
}

export function FirmwareHeader({
  title,
  badgeText,
  setSearchText,
  onUploadClick,
}: FirmwareHeaderProps) {
  return (
    <>
      <Header
        title={title}
        badgeText={badgeText}
        button={{ text: "Upload", onClick: onUploadClick }}
      />
      <div className="flex flex-row items-center justify-between">
        <h3 className="text-xl font-semibold text-primary-50 dark:text-primary-80">
          All Versions
        </h3>
        <SearchInput
          placeholder="Search by version"
          onValueChange={setSearchText}
        />
      </div>
    </>
  );
}
